import React from 'react'
import styled from '@emotion/styled'
import ManageFilter from '../components/ManageFilter'
import MultiManageSelector from '../components/MultiManageSelector'
import icons from "../assets/images/ico2.png";

const Logo = styled('img')(({ size }) => ({
    width: `${120 * (size || 1)}px`,
}));

const Container = styled.div`
    border: 2px solid #444;
    border-radius: 20px;
    padding: 8px;
    margin: 20px;
    height: 90vh;
    display: flex;
    flex-direction: column;
    align-items:center;
`


function ManagementPage() {
  return (
    <Container>
        <Logo src={icons} alt="logo" size={2} />
        <ManageFilter />
        <MultiManageSelector />
    </Container>
  )
}

export default ManagementPage;

